import { render, staticRenderFns } from "./ManageBlockSlidesPopup.vue?vue&type=template&id=2da340c6&scoped=true&"
import script from "./ManageBlockSlidesPopup.vue?vue&type=script&lang=js&"
export * from "./ManageBlockSlidesPopup.vue?vue&type=script&lang=js&"
import style0 from "./ManageBlockSlidesPopup.vue?vue&type=style&index=0&id=2da340c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da340c6",
  null
  
)

export default component.exports